import ParamSchema from '../schemas/ParamSchema'

export default function ParamVo(initData = {}) {
  return ParamSchema.validateSync(initData)
}
